/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableDataV2,
    JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableDataV2ToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableDataV2';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData {
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableDataV2}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
     */
    availableData?: JpCoBenefitoneBsSubsidyDtoAvailableDataV2;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
     */
    remainingCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
     */
    availableRemainingCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
     */
    remainingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
     */
    availableRemainingAmount?: number;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData
     */
    scrennDisplayItemList?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'availableData': !exists(json, 'availableData') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSON(json['availableData']),
        'remainingCount': !exists(json, 'remainingCount') ? undefined : json['remainingCount'],
        'availableRemainingCount': !exists(json, 'availableRemainingCount') ? undefined : json['availableRemainingCount'],
        'remainingAmount': !exists(json, 'remainingAmount') ? undefined : json['remainingAmount'],
        'availableRemainingAmount': !exists(json, 'availableRemainingAmount') ? undefined : json['availableRemainingAmount'],
        'scrennDisplayItemList': !exists(json, 'scrennDisplayItemList') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListFromJSON(json['scrennDisplayItemList']),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'availableData': JpCoBenefitoneBsSubsidyDtoAvailableDataV2ToJSON(value.availableData),
        'remainingCount': value.remainingCount,
        'availableRemainingCount': value.availableRemainingCount,
        'remainingAmount': value.remainingAmount,
        'availableRemainingAmount': value.availableRemainingAmount,
        'scrennDisplayItemList': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListToJSON(value.scrennDisplayItemList),
    };
}

